import PropTypes from "prop-types";
import { memo } from "react";
import { useSelector } from "react-redux";

import AppPropTypes, {
  MOT_FERRY,
  MOT_NATIONAL,
  MOT_REGIONAL,
  MOT_UBAHN,
} from "../model/propTypes";
import getElevatorStateTitle from "../utils/getElevatorStateTitle";

import {
  Accessibility,
  Airport,
  Ferry,
  Fvicon as Train,
  Ubahn as UBahn,
  Zob,
} from "./icons";
import StationIconButton from "./StationIconButton";
import StationIconElevator from "./StationIconElevator";

import "./StationIcons.scss";

const propTypes = {
  elevatorOutOfOrder: PropTypes.bool,
  hasAccessibility: PropTypes.bool,
  hasAirport: PropTypes.bool,
  hasElevator: PropTypes.bool,
  hasTransfer: PropTypes.bool,
  hasZOB: PropTypes.bool,
  trackEventCategory: PropTypes.string,
  transfers: AppPropTypes.transfers,
};

function StationIcons(props) {
  const {
    hasAccessibility,
    hasAirport,
    hasElevator,
    hasTransfer = true,
    hasZOB,
    trackEventCategory,
    transfers,
  } = props;
  const config = useSelector((state) => state.config?.stationIcons);
  const trainIcon = useSelector((state) => state.config?.trainIcon);
  const mots = [];

  let uBahnTitle;
  if (hasTransfer) {
    // Sbahnm use transfers property
    if (transfers && transfers.length) {
      transfers.forEach(({ lines, mot }) => {
        mots.push(mot);
        if (mot === MOT_UBAHN) {
          uBahnTitle = `U-Bahn${
            lines && lines.length ? `: ${lines.join(", ")}` : ""
          }`;
        }
      });
    }
  }

  const hasUBahn = mots.includes(MOT_UBAHN);
  const hasRegionalTrain = mots.includes(MOT_REGIONAL);
  const hasLongDistanceTrain = mots.includes(MOT_NATIONAL);
  const hasFerry = mots.includes(MOT_FERRY);
  let trainTitle =
    hasRegionalTrain &&
    hasLongDistanceTrain &&
    "Fern-/Regionalverkehrsanschluss";

  if (!trainTitle) {
    trainTitle =
      hasRegionalTrain && MOT_REGIONAL && "Regionalverkehrsanschluss";
  }

  if (!trainTitle) {
    trainTitle =
      hasLongDistanceTrain && MOT_NATIONAL && "Fernverkehrsanschluss";
  }

  const elevatorTitle = getElevatorStateTitle(props, config);

  return (
    <div className="station-icons">
      {config.hasElevator &&
        (hasElevator === true || config.forceDisplayElevator) && (
          <StationIconButton
            legendPopupProps={{ onlyElevatorInfo: true, station: props }}
            title={elevatorTitle}
            trackEventCategory={trackEventCategory}
          >
            <StationIconElevator {...props} />
          </StationIconButton>
        )}
      {config.hasAccessibility &&
        (hasAccessibility === true || config.forceDisplayAccessibility) && (
          <StationIconButton
            title="Barrierefreier Bahnhof, Aufzugstatus beachten"
            trackEventCategory={trackEventCategory}
          >
            <Accessibility data-testid="accessibility-icon" />
          </StationIconButton>
        )}
      {config.hasAirport && hasAirport === true && (
        <StationIconButton
          title="Flughafen"
          trackEventCategory={trackEventCategory}
        >
          <Airport data-testid="airport-icon" />
        </StationIconButton>
      )}
      {hasTransfer &&
        ((config.hasRegionalTrain && hasRegionalTrain === true) ||
          (config.hasLongDistanceTrain && hasLongDistanceTrain === true)) && (
          <StationIconButton
            title={trainTitle}
            trackEventCategory={trackEventCategory}
          >
            {trainIcon || <Train data-testid="fv-icon" />}
          </StationIconButton>
        )}
      {hasTransfer && config.hasFerry && hasFerry === true && (
        <StationIconButton
          title={MOT_FERRY}
          trackEventCategory={trackEventCategory}
        >
          <Ferry data-testid="ferry-icon" />
        </StationIconButton>
      )}
      {config.hasZOB && hasZOB === true && (
        <StationIconButton
          className="trl-icon-zob"
          title="Zentraler Omnibusbahnhof"
          trackEventCategory={trackEventCategory}
        >
          <Zob data-testid="zob-icon" />
        </StationIconButton>
      )}
      {hasTransfer && config.hasUBahn && hasUBahn === true && (
        <StationIconButton title={uBahnTitle}>
          <UBahn data-testid="ubahn-icon" />
        </StationIconButton>
      )}
    </div>
  );
}

StationIcons.propTypes = propTypes;

export default memo(StationIcons);
